import React from "react";
import i18next from "i18next";
import {ArrowRightOutlined, LoadingOutlined} from "@ant-design/icons";

// The account already signed in, as a tile to continue with, followed by a divider to the form.
// `page` is the ThemedLoginPage instance; continuing signs in exactly as LoginPage's own box does.
export function renderAvironSignedInAccount(page) {
  const account = page.props.account;
  const loading = !!page.state.loginLoading;
  const name = account.displayName || account.name;
  const detail = account.email || account.name;

  return (
    <div className="aviron-signed-in">
      <button type="button" className="aviron-account-tile" disabled={loading} aria-busy={loading} onClick={() => page.continueAsSignedInAccount()}>
        {
          account.avatar ?
            <img className="aviron-account-avatar" src={account.avatar} alt="" /> :
            <span className="aviron-account-avatar" aria-hidden="true">{name.slice(0, 1).toUpperCase()}</span>
        }
        <span className="aviron-account-text">
          <span className="aviron-account-label">{i18next.t("login:Continue with")}</span>
          <span className="aviron-account-name">{name}</span>
          {detail !== name ? <span className="aviron-account-detail">{detail}</span> : null}
        </span>
        {loading ? <LoadingOutlined className="aviron-account-arrow" /> : <ArrowRightOutlined className="aviron-account-arrow" />}
      </button>
      <div className="aviron-divider">{i18next.t("login:Or sign in with another account")}</div>
    </div>
  );
}
